import React from 'react';

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden w-full max-w-full">
      {/* Main Content */}
      <main className="flex-1 w-full overflow-x-hidden">
        <div className="w-full overflow-x-hidden">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-violet-900 via-purple-900 to-fuchsia-900 border-t border-purple-700 mt-auto w-full overflow-x-hidden">
        <div className="max-w-7xl mx-auto px-4 py-8 w-full">
          <div className="text-center text-white">
            <p className="text-purple-200 mb-2">© 2024 CryptoVista</p>
            <p className="text-purple-300 text-sm">Real-time cryptocurrency market data powered by Binance API</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;

